<div
  class="timeslot flex bg-white h-full"
  [ngClass]="containerClass"
  [class.timeslot--in-cart]="isTimeslotInCart"
>
  <div class="w-4/6">
    <p class="text-grey-dark-3 font-bold mb-1 timeslot__date">
      <time
        class="timeslot__start-date"
        [attr.datetime]="timeslot.startDate | localizedDate: 'y-MM-dd'"
        >{{ formattedStartDate }}</time
      >
    </p>

    <p *ngIf="!isEvent" class="flex text-xs">
      <span>
        {{ 'timeslot.start_at' | translate }}
        <time
          class="timeslot__start-time"
          [attr.datetime]="timeslot.startDate | localizedDate: 'HH:mm'"
        >
          {{ formattedStartTime }}<span>,</span>
        </time>
      </span>
      <span class="flex items-center mb-1 px-1">
        <time class="timeslot__duration" [attr.datetime]="ISODuration">
          {{ duration }}
        </time>
      </span>
    </p>
    <div class="flex flex-wrap items-center gap-2">
      <p
        class="text-xs flex-initial"
        [ngClass]="capacityClass"
        *ngIf="!timeslot.isExternal() && !isEvent"
      >
        <ng-container *ngIf="!timeslot.remainingAttendeeCapacity">
          {{ 'timeslot.full' | translate }}
        </ng-container>

        <ng-container *ngIf="timeslot.remainingAttendeeCapacity">
          {{ timeslot.remainingAttendeeCapacity }}
          {{ 'timeslot.remaining_spots' | translate }}
        </ng-container>
      </p>
      <p class="text-xs flex-initial" *ngIf="timeslot.isExternal()">
        {{ 'timeslot.book_external_mention' | translate }}
      </p>
      <span *ngIf="isStarted">
        <app-badge
          class="flex-none"
          [icon]="icon.WarningError"
          [variant]="yellowVariant"
        >
          {{ 'timeslot.in_progress' | translate }}
        </app-badge>
      </span>
    </div>

    <div class="font-bold mt-1">
      <ng-content select="[price-badge-left]"></ng-content>
    </div>
  </div>

  <div
    class="flex flex-col justify-between w-2/6 ml-3"
    [ngClass]="rightColumnClass"
  >
    <div class="font-bold">
      <ng-content select="[price-badge-right]"></ng-content>
    </div>

    <ng-content select="[cta]"></ng-content>
  </div>
</div>
